import { useState } from 'react';
import { VStack } from '@chakra-ui/react';
import ControlBar from './ControlBar';
import Week from './Week';
import Calendar from './Calendar';

import { DayType } from './type';

type DatePickerProps = {
  date: Date | null;
  dayRuleFn: (date: Date) => DayType;
  onChangeDate: (date: Date) => void;
};

export default function DatePicker({ date, onChangeDate, dayRuleFn }: DatePickerProps) {
  const [controlDate, setControlDate] = useState(date || new Date());

  return (
    <VStack align="stretch" spacing={5}>
      <ControlBar date={controlDate} onChangeDate={(date) => setControlDate(date)} />
      <Week />
      <Calendar controlDate={controlDate} dayRuleFn={dayRuleFn} onChangeDate={onChangeDate} />
    </VStack>
  );
}
